const isValidData = (data) => {
  return data != null && data !== 'undefined' && data !== 'false' && data !== '';
};

const isValidBase64 = (str) => {
  // Check if string is valid Base64 format
  const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
  return base64Regex.test(str);
};

const parseAllZones = (isTottusSA, cookies, appCtx, logger) => {
  const defaultResult = { expressZones: [], standardZones: [] };

  if (!isTottusSA || !isValidData(cookies?.zonesList)) {
    return defaultResult;
  }

  try {
    if (!isValidBase64(cookies.zonesList)) {
      throw new Error('Invalid Base64 format');
    }

    const decodedZones = Buffer.from(cookies.zonesList, 'base64').toString('utf8');
    const parsedZones = JSON.parse(decodedZones);

    // Validate parsed data structure
    if (typeof parsedZones !== 'object' || parsedZones === null) {
      throw new Error('Parsed zones is not a valid object');
    }

    return {
      expressZones: Array.isArray(parsedZones.expressZones) ? parsedZones.expressZones : [],
      standardZones: Array.isArray(parsedZones.standardZones) ? parsedZones.standardZones : [],
    };
  } catch (error) {
    logger?.error(`Error parsing zonesList: ${error.message}`, { appCtx: appCtx?.regionCode });
    return defaultResult;
  }
};

const hasVariants = (prod) =>
  Array.isArray(prod.variants) && prod.variants.some((v) => Array.isArray(v.options) && v.options.length > 0);

export { isValidData, parseAllZones, hasVariants };
